import React from 'react';
import Layout from './Layout';
import Formwizard from '../../../wizard';

import UserDataStep from './UserDataStep';

const Clean = React.forwardRef(({ ...props }, ref) => (
  <Layout ref={ref}>
    <Formwizard
      components={{
        UserDataStep,
      }}
      {...props}
    />
  </Layout>
));

export default Clean;
